module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/good_selected.96bbf4f9.gif";